import React from 'react';
import Moment from 'react-moment';

import { useFleet } from '../../hooks/useFleet';
import { CustomerOnly, InternalOnly } from './adminOnly';
import { timezonesEnum } from '../../utils';

interface Props {
  children: string;
}

export function Time(props: Props) {
  const fleet = useFleet();
  const timezone = fleet.timezone ?? timezonesEnum.AMERICA_NEW_YORK;

  return (
    <>
      <InternalOnly>
        <Moment tz={timezone} format="hh:mm:ss A">
          {props.children}
        </Moment>
      </InternalOnly>

      <CustomerOnly>
        <Moment tz={timezone} format="hh:mm A">
          {props.children}
        </Moment>
      </CustomerOnly>
    </>
  );
}
